// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --widget-filespace-card-bg-color: linear-gradient(
        172deg,
        var(--ds-color-grey-60) 0%,
        var(--ds-color-grey-100) 100%
    );
    --widget-filespace-card-active-bg-color: linear-gradient(
        172deg,
        var(--ds-color-grey-40) 0%,
        var(--ds-color-grey-90) 100%
    );
    --widget-filespace-card-focus-bg-color: linear-gradient(
        172deg,
        var(--ds-color-grey-40) 0%,
        var(--ds-color-grey-90) 100%
    );
    --widget-filespace-card-hover-bg-color: linear-gradient(
        172deg,
        var(--ds-color-grey-40) 0%,
        var(--ds-color-grey-90) 100%
    );
    --widget-filespace-card-border-color: var(--ds-color-grey-60);
    --widget-filespace-card-outline-active-color: var(--ds-color-grey-10);
    --widget-filespace-card-outline-focus-color: var(--ds-color-focus-outline);
    --widget-filespace-card-outline-hover-color: var(--ds-color-grey-20);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
